import { Checkbox, FormControlLabel } from "@mui/material";
import { type FC } from "react";
import { IPopupTranslations } from "./FilterItem";
import SearchIcon from "@mui/icons-material/Search";
import { useScreenSize } from "src/hooks/useScreenSize";

interface FilterPopupListProps {
  itemList: IFilterListItem[];
  setItemList: (a: IFilterListItem[]) => void;
  popupTranslation: IPopupTranslations;
  setSearch: (s: string) => void;
  search: string;
}

export interface IFilterListItem {
  value: string;
  translation: string;
  isActive?: boolean;
}

const FilterPopupList: FC<FilterPopupListProps> = ({
  popupTranslation,
  itemList,
  setItemList,
  setSearch,
  search,
}) => {
  const updateList = (item: IFilterListItem, setActive: boolean) => {
    const newList = [...itemList];
    const itemIdx = newList.findIndex((i) => i.value == item.value);
    newList[itemIdx] = { ...item, isActive: setActive };
    setItemList(newList);
  };
  const smAndDown = useScreenSize("sm", "down");

  return (
    <div className="filter_popup">
      <div className="filter_popup_subtitle">{popupTranslation.title}</div>
      {smAndDown && (
        <div className="search-box__input">
          <input
            type="text"
            placeholder={popupTranslation.placeholder}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <div className="search-box__iconBox">
            <SearchIcon />
          </div>
        </div>
      )}
      {!smAndDown && (
        <input
          type="text"
          placeholder={popupTranslation.placeholder}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      )}
      {itemList.filter((i) => i.isActive).length > 0 && (
        <div className="filter_popup_list_wrap filter_popup_list_wrap_first">
          <div className="filter_popup_list filter_popup_list_first">
            {itemList
              .filter((i) => i.isActive)
              .map((item, i) => (
                <FormControlLabel
                  className="filter_popup_list_item"
                  key={item.value + i}
                  control={
                    <Checkbox
                      size="small"
                      color="default"
                      checked={true}
                      onClick={() => updateList(item, false)}
                    />
                  }
                  label={item.translation}
                />
              ))}
          </div>
        </div>
      )}
      {itemList.filter((i) => !i.isActive).length > 0 && (
        <div className="filter_popup_list_wrap ">
          <div className="filter_popup_list">
            {itemList
              .filter((i) => !i.isActive)
              .map((item, i) => (
                <FormControlLabel
                  className="filter_popup_list_item"
                  key={item.value + i}
                  control={
                    <Checkbox
                      size="small"
                      color="default"
                      checked={false}
                      onClick={() => updateList(item, true)}
                    />
                  }
                  label={item.translation}
                />
              ))}
          </div>
        </div>
      )}
    </div>
  );
};
export default FilterPopupList;
